import { IconButton, TextField } from '@mui/material';
import { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { SettingsInputProps } from './SettingsInputProps';
import { TranslationAdornment } from '../../Translation/TranslationAdornment';

export const TextSettingsInput = (props: SettingsInputProps) => {
  const [mask, setMask] = useState(props.masked ?? false);

  const resolvedValue = props.value?.stringValue ?? '';

  let endAdornment = props.endAdornment;
  if (props.masked) {
    endAdornment = (
      <IconButton
        size='small'
        color='primary'
        onClick={() => setMask((x) => !x)}
      >
        {mask ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    );
  }
  if (props.localized) {
    endAdornment = (
      <TranslationAdornment
        defaultValue={resolvedValue}
        value={props.value?.translatedTextValue ?? {}}
        onChange={(x) =>
          props.onChange({ stringValue: resolvedValue, translatedTextValue: x })
        }
      />
    );
  }

  return (
    <TextField
      variant='outlined'
      size='small'
      fullWidth
      value={resolvedValue}
      onChange={(e) =>
        props.onChange({
          stringValue: e.target.value,
          translatedTextValue: props.value?.translatedTextValue,
        })
      }
      multiline={props.multiline}
      placeholder={props.placeholder}
      InputProps={{ endAdornment }}
      sx={{
        '& input': {
          WebkitTextSecurity: mask ? 'disc' : 'none',
        },
      }}
    />
  );
};
